import { IFavouritesState, IPagination } from '../states';

export const initialFavouritesState: IFavouritesState = {
  value: [],
  pagination: {} as IPagination,
};
